export enum OrderReportLanguageEnum {
  TH = "TH",
  CN = "CN"
}

export const ORDER_REPORT_LANGUAGE_CHOICES = [
  {
    label: "TH",
    value: OrderReportLanguageEnum.TH
  },
  {
    label: "CN",
    value: OrderReportLanguageEnum.CN
  }
];
